import { useUnit } from 'effector-react'
import { createRef, useEffect, useState } from 'react'
import { goToAuth } from '@/app/routing/events'
import { $userSteamAuthUrl } from '@/entities/user'
import { Iframe } from '@/shared/ui/iframe'

export const NewAuthPageView = () => {
  const authUrl = useUnit($userSteamAuthUrl)
  const [userUrl, setUserUrl] = useState<string>('')
  const iFrameRef = createRef<HTMLIFrameElement>()

  useEffect(() => {
    if (authUrl) {
      setUserUrl(authUrl)
    }
  }, [authUrl])

  useEffect(() => {
    const frame = iFrameRef.current
    if (frame) {
      const handleLoad = () => {
        const currentUrl = frame.src
        const appUrl = frame.contentWindow?.location.href
        if (currentUrl == appUrl) {
          goToAuth()
        }
      }
      frame.addEventListener('load', handleLoad)
      return () => frame.removeEventListener('load', handleLoad)
    }
  }, [userUrl, iFrameRef])

  return (
    <>
      <Iframe
        url={userUrl}
        ref={iFrameRef}
      />
    </>
  )
}
